import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'Cloud Solutions', path: '/services' },
      { name: 'Business Support', path: '/services' },
      { name: 'Advertisement & Marketing', path: '/services' },
      { name: 'SMM Management', path: '/services' },
    ],
    solutions: [
      { name: 'Enterprise', path: '/services' },
      { name: 'SMB', path: '/services' },
      { name: 'Startup', path: '/services' },
      { name: 'Government', path: '/services' },
    ],
    company: [
      { name: 'About', path: '/' },
      { name: 'Careers', path: '/' },
      { name: 'Partners', path: '/' },
      { name: 'News', path: '/' },
    ],
    resources: [
      { name: 'Blog', path: '/' },
      { name: 'Documentation', path: '/' },
      { name: 'Support', path: '/contact' },
      { name: 'Community', path: '/' },
    ],
  };

  return (
    <footer className="bg-gradient-to-br from-teal-900 to-slate-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="world-map" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="1" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#world-map)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-4">
            <div className="mb-6">
              <span className="text-2xl font-extrabold tracking-widest text-white">
                VORENN <span className="text-cyan-400">TECH</span>
              </span>
            </div>
            <h3 className="text-3xl font-serif mb-6 leading-tight">
              Securing Your<br />Digital Future
            </h3>
            <div className="flex items-center space-x-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-transparent border border-teal-400/50 rounded-lg text-white placeholder-teal-200/50 focus:outline-none focus:border-cyan-400 text-sm"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-cyan-500 rounded-full hover:bg-cyan-600 transition-colors cursor-pointer">
                <i className="ri-notification-line text-white text-lg"></i>
              </button>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-bold mb-4">Services</h4>
              <ul className="space-y-2">
                {footerLinks.services.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-teal-100 hover:text-cyan-300 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Solutions</h4>
              <ul className="space-y-2">
                {footerLinks.solutions.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-teal-100 hover:text-cyan-300 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Company</h4>
              <ul className="space-y-2">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-teal-100 hover:text-cyan-300 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Resources</h4>
              <ul className="space-y-2">
                {footerLinks.resources.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-teal-100 hover:text-cyan-300 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-teal-700/50">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-teal-200">
              © {currentYear} VORENN TECH. All rights reserved.
            </p>

            <div className="flex items-center space-x-5">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-teal-400/50 rounded-lg hover:bg-cyan-500/20 hover:border-cyan-400 transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-teal-400/50 rounded-lg hover:bg-cyan-500/20 hover:border-cyan-400 transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-teal-400/50 rounded-lg hover:bg-cyan-500/20 hover:border-cyan-400 transition-all cursor-pointer"
              >
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-teal-400/50 rounded-lg hover:bg-cyan-500/20 hover:border-cyan-400 transition-all cursor-pointer"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>

            <div className="flex items-center space-x-4 text-sm text-teal-200">
              <Link
                to="/refund-policy#refund-eligibility"
                className="hover:text-cyan-300 transition-colors cursor-pointer"
              >
                Refund Policy
              </Link>
              <span>|</span>
              <Link
                to="/refund-policy#service-usage"
                className="hover:text-cyan-300 transition-colors cursor-pointer"
              >
                Privacy Policy
              </Link>
              <span>|</span>
              <Link
                to="/refund-policy#terms-and-conditions"
                className="hover:text-cyan-300 transition-colors cursor-pointer"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
